import React, { Component } from 'react';
import AuthService from './AuthService';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { filter } from 'lodash'

//const buildingsJson = require('./JSON/buildings')

//added 06-27-18
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Contactus from './Contactus';
// end added 06-27-18

class Builderdropdown extends Component {
    
    state = { 
        buildings:[],
        selected: undefined,
        loading: true
    }
  
    constructor(props) {
      super(props);
  
      this.getToken = this.getToken.bind(this);
      this.fetchBuildings = this.fetchBuildings.bind(this);
      this.onChange = this.onChange.bind(this);
    }

    fetchBuildings(client) {
        if(!client) {
            return
        }
        
        const bearerToken = this.getToken();

        this.setState({ loading: true }, () => {
            fetch(`https://simulateapiprod.azurewebsites.net/api/buildings/${client.crg_energyprogramid}`, {
            // fetch(`https://astcloudrestservice.azurewebsites.net/api/buildings/${client.crg_energyprogramid}`, {
            method: 'GET',
            headers: {
                        'Content-type': 'application/json',
                        'Authorization': `Bearer ${bearerToken}`
                    },
                })
                .then(results => results.json())
                .then(buildings => {
                    this.setState({ buildings: buildings, loading: false })
                    
                })
            
        })
    }
        //const buildings = filter(buildingsJson, { crg_energyprogramid: client.crg_energyprogramid })
        
    
    
    
  onChange(e) {
    if(!e) {
        this.setState({
            selected: null
        });
        this.props.onSelect(null);
        return;
    }

    const id = e.crg_buildingid;
    this.setState({ selected: id })

    const building = this.state.buildings.find(x => x.crg_buildingid === id);
    this.props.onSelect(building)
  }

componentDidMount() {
    if(this.props.client) {
        this.fetchBuildings(this.props.client);
    }
}

componentWillReceiveProps(props) {
    if(this.props.client !== props.client) {
        this.fetchBuildings(props.client);
    }
}
    
      
    getToken() {
        return localStorage.getItem('id_token');
    }

    render() {
        const { showHelpTab } = this.props;
        if(this.state.loading) {
            return <p>Loading...</p>
        }
        //console.log(this.state.buildings);
        if(this.state.buildings.length === 0) {
            return <p>No buildings found, please email <a className="contact_lnk" href="mailto:support@cenergistic.com">support@cenergistic.com</a> for assistance.</p>;
            // return <p>No buildings found, please email: <a href='mailto:support@cenergistics.com'>support@cenergistics.com</a> for assistance.</p>;
        }
        return(
            <div>
            {/* <select className="custom-select" id="siteName" value={this.state.selected} onChange={this.onChange}>
            <option value={null} selected>Buildings</option>
                    { this.state.buildings.map((item, index) =>(
                    <option key={item.crg_buildingid + index} value={item.crg_buildingid}>{item.siteName}</option>
                    ))
                    }
                </select> */}
            <Select
                // className="custom-select" 
                // id="siteName"
                name="building-dropdown"
                clearable={true}
                value={this.state.selected}
                onChange={this.onChange}
                options={this.state.buildings.map(item => {
                    item.value = item.crg_buildingid;
                    item.label  = item.siteName;
                    return item;
                })}
            />
            </div>
        );
    }

}

export default Builderdropdown;



// WEBPACK FOOTER //
// ./src/components/Builderdropdown.js